export const RESET = 'EXSBPOSITION_UPDATE_RESET'
export const SET_ERROR = 'EXSBPOSITION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPOSITION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPOSITION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPOSITION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPOSITION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPOSITION_UPDATE_UPDATE_RETRIEVED'
